import { XModal, XComponentModal } from './xmodal';
import { XDrawer } from './xdrawer';

export const install = function (app) {
    app.component(XModal.name, XModal);
    app.component(XComponentModal.name, XComponentModal);
    app.component(XDrawer.name, XDrawer);
};

export {
    XModal,
    XComponentModal,
    XDrawer,
};

